import { gql } from '@apollo/client';

export const GET_AD_PRODUCT = gql`
  query GET_AD_PRODUCT {
    getLineItemAdProductV5
  }
`;
